_ = require 'underscore'

isValidDataImage = (url) ->
  _.isString(url) &&
  /^data:image\/(?:png|jpg|jpeg|gif|svg\+xml);base64,[A-Za-z0-9+\/=_-]+$/.test(url)

isValidHttp = (url) ->
  _.isString(url) &&
  /^https?:\/\//.test(url)

isValidUrlForImage = (url) ->
  isValidHttp(url) || isValidDataImage(url)

# when putting image URLs in CSS, we don't want you to be able
# to escape the CSS property with a ' or " and try to set other
# css properties behind our backs
isValidUrlForCSSImage = (url) ->
  isValidUrlForImage(url) && !/['"]/.test(url)

isValidUrlForIframe = (url) ->
  isValidHttp(url)

isValidHeight = (height, maxHeight = Infinity, minHeight = 1) ->
  if !height? || !_.isNumber(height)
    return false
  return height >= minHeight && height <= maxHeight

isValidHexColor = (colorString) ->
  if _.isString(colorString) && /^#([0-9a-f]{3}|[0-9a-f]{6})$/i.test(colorString)
    return true

  return false

# Expected Shape of pluginBadge:
#   icon?: url
#   text?: string | number
#   title?: string (cardDetail)
#   color?: string
#   dynamic?: function
#   refresh?: number
#   callback?: function (cardDetail)
#   url?: string (cardDetail)
#   target?: string (cardDetail)
isValidBadge = (pluginBadge) ->
  if !pluginBadge? || !_.isObject(pluginBadge)
    return false
  if pluginBadge.text? && (!_.isString(pluginBadge.text) && !_.isFinite(pluginBadge.text))
    return false
  if pluginBadge.title? && !_.isString(pluginBadge.title)
    return false
  if pluginBadge.icon? && !isValidUrlForCSSImage(pluginBadge.icon)
    return false
  if pluginBadge.dynamic? && !_.isFunction(pluginBadge.dynamic)
    return false
  if pluginBadge.refresh? && !_.isFinite(pluginBadge.refresh)
    return false

  return true

isRenderableBadge = (pluginBadge, cardDetail) ->
  # do we have enough data in this badge to render something meaningful
  if !isValidBadge(pluginBadge, cardDetail)
    return false
  if cardDetail
    # card detail badges need at least text
    # should it also require a title?
    # probably, but we haven't been enforcing that so :shrug:
    return _.isString(pluginBadge.text) || _.isFinite(pluginBadge.text)
  else
    # card front badge need at least text or an icon
    return isValidUrlForCSSImage(pluginBadge.icon) || _.isString(pluginBadge.text) || _.isFinite(pluginBadge.text)

# Expected Shape of pluginCover:
#   height: Number
#   url: string
#   edgeColor?: string
#   position?: 'cover' | { padding: boolean, align: 'left'|'right'|'center'}
isValidCover = (pluginCover, cardDetail) ->
  MAX_HEIGHT = 256
  MIN_HEIGHT = if cardDetail then 64 else 8
  if !pluginCover? || !_.isObject(pluginCover)
    return false
  if !isValidUrlForCSSImage(pluginCover.url)
    console?.warn('Invalid URL supplied for card-cover', pluginCover.url)
    return false
  if !isValidHeight(pluginCover.height, MAX_HEIGHT, MIN_HEIGHT)
    console?.warn('Invalid height supplied for card-cover', pluginCover.height)
    return false

  return true

isValidAlertDisplayType = (displayType) ->
  return displayType in ['info', 'success', 'warning', 'error']

isValidAlertDuration = (duration) ->
  return _.isNumber(duration) && duration >= 5 && duration <= 30

isValidStringLength = (str, min, max) ->
  return _.isString(str) && str.length >= min && str.length <= max

module.exports = {
  isRenderableBadge,
  isValidAlertDisplayType,
  isValidAlertDuration,
  isValidBadge,
  isValidCover,
  isValidHeight,
  isValidHexColor,
  isValidStringLength,
  isValidUrlForCSSImage,
  isValidUrlForIframe
  isValidUrlForImage,
}



// WEBPACK FOOTER //
// ./app/scripts/lib/plugins/plugin-validators.coffee